import React from 'react';
import { BarChart, Loading } from '@dsi/react-eds';
import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import styles from './MostFrequentFailedStages.module.css';
import { useMostFailedStages, MostFailedStages } from './../hooks/use-most-failed-stages';

interface MostFrequentFailedStagesProps {
  startDate: string;
  endDate: string;
  onMaximize?: () => void;
  isMaximized?: boolean;
}

const MostFrequentFailedStages: React.FC<MostFrequentFailedStagesProps> = ({ startDate, endDate }) => {
  const { data, isLoading, isError } = useMostFailedStages(startDate, endDate);
  const chartKey = `${startDate}-${endDate}`;

  return (
    <div>
      {isLoading && (
        <div className={styles.loadingContainer}>
          <ReactEDSWrapper component={Loading} size="large" />
        </div>
      )}
      {isError && <div className={styles.loadingText}>Error while loading most failed stages data.</div>}

      {!isLoading &&
        !isError &&
        data &&
        (() => {
          if (data.length === 0) {
            return (
              <div className={styles.noDataContainer}>
                <i className={`icon icon-failed ${styles.dangerIcon}`} />
                <div className={styles.noDataTitle}>Data Unavailable</div>
                <div className={styles.noDataSubtitle}>No failed stages data available for the selected time range</div>
              </div>
            );
          }

          const seriesData = data.map((s: MostFailedStages) => {
            return { name: s.stage, values: [s.total] };
          });
          const chartData = {
            common: ['Top 4 Failed Stages'],
            series: seriesData
          };
          return (
            <div className={styles.chartContainer}>
              <ReactEDSWrapper
                key={chartKey}
                component={BarChart}
                id={`most-frequent-failed-stages-chart-${chartKey}`}
                data={chartData}
                y={{ unit: 'Failed Stages' }}
                vertical
                grouped={true}
                barWidth={15}
                height={300}
              />
            </div>
          );
        })()}
    </div>
  );
};

export default MostFrequentFailedStages;
